<template>
  <MainLayout>
    <v-container class="mt-10">
      <v-row>
        <v-breadcrumbs :items="breadcrumbs">
          <template v-slot:prepend>
            <v-icon icon="$vuetify" size="small"></v-icon>
          </template>
        </v-breadcrumbs>
        <v-col>
          <v-btn
            @click="showAddTechnicalServiceDialog"
            color="primary float-right"
            >Teknik Servis Kaydı Ekle</v-btn
          >
          <!-- Stok Ekle Butonu -->
        </v-col>
        <v-divider></v-divider>
      </v-row>

      <v-dialog v-model="addTechnicalServiceDialog" max-width="1000px">
        <v-card>
          <v-card-title>
            <span class="headline">Stok Ekle</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12" sm="6">
                  <div style="display: flex; align-items: center">
                    <v-autocomplete
                      v-model="newTechnicalService.selectedCustomer"
                      :items="customerList"
                      :loading="loading"
                      item-text="title"
                      item-value="id"
                      label="Müşteri Ara"
                      solo
                      hide-no-data
                      hide-selected
                      @input="(event) => fetchCustomers(event.target.value)"
                    ></v-autocomplete>
                    <v-btn
                      color="blue"
                      @click="addCustomer"
                      style="margin-left: 8px"
                    >
                      <v-icon>mdi mdi-account-group</v-icon>
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="6">
                  <SellerSelect v-model="newTechnicalService.seller_id"  @input="validateSellers()" required label="Gönderici Bayi"  :rules="[rules.required]" />
                
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="newTechnicalService.brand"
                    :items="brandList"
                    @input="getModel(newStock.brand)"
                    label="Marka"
                    :rules="[rules.required]"
                    item-title="name"
                    item-value="id"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="newTechnicalService.model"
                    :items="modelList"
                    label="Model"
                    :loading="loading"
                    item-title="name"
                    item-value="id"
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="newTechnicalService.physicallyDescription"
                    label="Fiziksel Açıklama"
                    :rules="[rules.required]"
                    required
                  ></v-textarea>
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-model="
                      newTechnicalService.accessoryCategory[0]
                        .accessoryCategoryId
                    "
                    :items="accessoryCategoryList"
                    label="Aksesuar Kategorisi"
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-model="
                      newTechnicalService.faultCategory[0].faultCategoryId
                    "
                    :items="faultCategoryList"
                    label="Arıza Kategorisi"
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-model="
                      newTechnicalService.physicallyCategory[0]
                        .physicallyCategoryId
                    "
                    :items="physicallyCategoryList"
                    label="Fiziksel Kategori"
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="newTechnicalService.accessoryDescription"
                    label="Aksesuar Açıklaması"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="newTechnicalService.faultDescription"
                    label="Arıza Açıklaması"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="addStock">Ekle</v-btn>
            <v-btn color="grey" text @click="addStockDialog = false"
              >İptal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row>
        <v-col>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-title> Filtreleme </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row>
                  <v-col>
                    <div class="d-flex justify-center">
                      <v-date-input
                        v-model="filter.date"
                        label="Select range"
                        multiple="range"
                      ></v-date-input>
                    </div>
                  </v-col>
                  <v-col
                    ><v-text-field
                      v-model="filter.customer"
                      placeholder="Cari Bilgisi"
                      hide-details
                    ></v-text-field
                  ></v-col>
                  <v-col
                    ><v-text-field
                      v-model="filter.seller"
                      placeholder="Şube"
                      hide-details
                    ></v-text-field
                  ></v-col>
                  <v-col
                    ><v-text-field
                      v-model="filter.price"
                      placeholder="Tutar"
                      hide-details
                    ></v-text-field
                  ></v-col>
                  <v-col
                    ><v-text-field
                      v-model="filter.serial"
                      placeholder="Seri No"
                      hide-details
                    ></v-text-field
                  ></v-col>
                  <v-col
                    ><v-btn
                      class="text-none mb-4"
                      color="indigo-darken-3"
                      @click="dialog = false"
                      >Filtrele</v-btn
                    ></v-col
                  >
                </v-row>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="saleList"
            v-model:options="options"
            :server-items-length="totalItems"
            :loading="loading"
            :search="search"
            :items-per-page="10"
            :items-per-page-options="[10, 25, 50, 100]"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 100],
              'items-per-page-text': 'Sayfa başına kayıt',
              'page-text': '{0}-{1} / {2}',
            }"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Teknik Servis</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  label="Ara..."
                  class="mx-4"
                  solo
                  clearable
                ></v-text-field>
              </v-toolbar>
            </template>

            <template v-slot:item="{ item }">
              <tr>
                <td style="width: 10%">{{ item.customer.name }}</td>
                <td style="width: 10%">{{ item.total_price }}</td>
                <td style="width: 10%">{{ item.created_at }}</td>
                <td style="width: 10%">
                  <v-btn
                    style="width: 30px; height: 30px"
                    icon
                    @click="showSerialNumbers(item.serial_numbers)"
                  >
                    <v-icon style="font-size: small">mdi-eye</v-icon>
                    <!-- Buton ikonu -->
                  </v-btn>
                </td>
                <td style="width: 10%">
                  <v-chip color="red">
                    {{ mapStatus(item.status) }}
                  </v-chip>
                </td>
                <td class="text-end" style="width: 20%">
                  <v-btn
                    v-if="
                      item.buyerSeller == this.seller_id &&
                      item.status == 'pending'
                    "
                    size="30"
                    @click="approved(item.id, 'complated')"
                    color="primary"
                    class="icon-size"
                    icon
                  >
                    <v-icon color="white" size="15">mdi-briefcase-check</v-icon>
                    <!-- Silme ikonu -->
                  </v-btn>
                  <v-btn
                    v-if="
                      item.buyerSeller == this.seller_id &&
                      item.status == 'pending'
                    "
                    size="30"
                    @click="approved(item.id, 'cancelled')"
                    color="danger"
                    class="icon-size"
                    icon
                  >
                    <v-icon color="white" size="15">mdi-cancel</v-icon>
                    <!-- Silme ikonu -->
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </MainLayout>
</template>

<script>
import {  useStore } from "vuex";
import { computed } from "vue";
import mainService from "@/services/mainService";
import MainLayout from "@/layouts/MainLayout.vue";
import Swal from "sweetalert2";
import SellerSelect from "@/components/SellerSelect.vue";

export default {
  name: "TechnicalServiceList",

  setup() {
    const store = useStore();
    const brandList = computed(() => store.state.brandList);

    const fetchBrandList = () => {
      store.dispatch("fetchBrandList");
    };

    const customerList = computed(() => store.state.customerList);

    const fetchCustomers = (searchTerm) => {
      store.dispatch("fetchCustomers", searchTerm); // Arama terimini geç
    };



    // Bileşen oluşturulduğunda satıcı listesini yükle
    fetchBrandList();
    return {
      fetchCustomers,
       brandList,
      customerList,
    };
  },

  components: {
    MainLayout,SellerSelect
  },

  created() {
    this.fetchTechnicalServiceList();
    const token = localStorage.getItem("user");
    this.seller_id = JSON.parse(token).seller_id;
  },
  data() {
    return {
      addTechnicalServiceDialog: false,
      breadcrumbs: [
        {
          title: "Anasayfa",
          disabled: false,
          href: "pDashboard",
        },
        {
          title: "Teknik Servis İşlemleri",
          disabled: false,
          href: "",
        },
      ],
      newTechnicalService: {
        customer: "",
        physicallyDescription: "",
        accessoryCategory: [
          { accessoryCategoryId: "" }, // Initial empty item
        ],
        faultCategory: [
          { faultCategoryId: "" }, // Initial empty item
        ],
        physicallyCategory: [
          { physicallyCategoryId: "" }, // Initial empty item
        ],
        accessoryDescription: "",

        faultDescription: "",
        seller_id: "",
        brand: "",
        model: "",
      },
      filter: {
        date: null,
        customer: "",
        seller: "",
        price: "",
        serial: "",
      },
      seller_id: "",
      totalItems: 3000,
      options: {
        page: 1,
        itemsPerPage: 10, // Varsayılan sayfa başına kayıt sayısı
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
      },
      headers: [
        { title: "Cari Bilgisi", value: "serial_number" },
        { title: "Toplam Tutar", value: "" },
        { title: "Personel", value: "" },
        { title: "Teknik Personel", value: "" },
        { title: "Ürünler", value: "" },
        { title: "Durumu", value: "" },
        { title: "İşlemler", value: "actions", sortable: false, align: "end" }, // Aksiyonlar için
      ],
      select: { name: "Seçiniz", id: "0" },
      technicalServiceList: [],
      loading: false, // Yükleniyor durumu
      search: "", // Arama metn
      valid: false, // Form geçerliliği
      rules: {
        required: (value) => !!value || "Bu alan gereklidir.",
      },
    };
  },

  computed: {
  },
  methods: {
    showAddTechnicalServiceDialog() {
      this.resetNewTechnicalService(); // Formu sıfırla
      this.addTechnicalServiceDialog = true; // Modalı göster
    },
    mapStatus(status) {
      const statusMap = {
        pending: "Beklemede",
        complete: "Tamamlandı",
        cancelled: "İptal Edildi",
        // Diğer durumlar...
      };
      return statusMap[status] || status; // Eğer durum haritada yoksa orijinal durumu döndür
    },

    fetchTechnicalServiceList() {
      this.loading = true;
      const page = this.options.page || 1;
      const limit = this.options.itemsPerPage || 50;
      const start = (page - 1) * limit;
      mainService
        .list("technical_service", {
          start: start,
          limit: limit,
        })
        .then((response) => {
          if (response && response.data) {
            this.technicalServiceList = response.data;
            this.totalItems = response.total;
          } else {
            console.error("Invalid response format:", response);
          }
        })
        .catch((error) => {
          console.error("Bir hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getModel(BrandId) {
      this.loading = true;
      const BrandToList = this.brandList.find((Brand) => Brand.id === BrandId);
      if (BrandToList) {
        this.modelList = BrandToList.models || []; // İlişkili modelleri al
        this.loading = false;
      } else {
        this.modelList = []; // Eğer marka bulunamazsa model listesini temizle
      }
    },
    async approved(id, status) {
      const { value: confirmDelete } = await Swal.fire({
        title: "Onaylamak istediğinize emin misiniz?",
        text: "Bu işlem geri alınamaz!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet, Devam Et!",
        cancelButtonText: "Hayır, iptal et!",
      });

      if (confirmDelete) {
        try {
          const response = await mainService.delete(id, status); // Kullanıcıyı silmek için servisi çağır
          this.fetchTechnicalServiceList(); // Kullanıcı listesini güncelle
          Swal.fire("Sonuç!", response, "success");
        } catch (error) {
          Swal.fire("Hata!", "Transfer Gerçekleşirken hata oluştu.", "error");
        }
      } else {
        Swal.fire(
          "İptal edildi",
          "Kullanıcı silme işlemi iptal edildi.",
          "info"
        );
      }
    },

    resetNewTechnicalService() {},
  },

  watch: {
    "newTechnicalService.brand": function (newVal) {
      this.getModel(newVal);
    },
    options: {
      handler() {
        this.fetchTechnicalServiceList();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
/* İsteğe bağlı stil ayarları */
.v-data-table {
  background-color: #ffffff;
  /* Beyaz arka plan */
  border-radius: 8px;
  /* Köşeleri yuvarla */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* Hafif gölge */
}

.icon-size {
  width: 30px;
  height: 30px;
}
</style>
